import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import { push } from "connected-react-router";
import styles from "../styles/Breadcrumb.module.scss";
import useDarkMode from "use-dark-mode";
import { useParams } from "react-router-dom";

const getItems = ({ card, dir, search }) => {
  if (!card) {
    return [];
  }

  const {
    cards,
    combos,
    is_partner,
    legal_commander,
    legal_companion,
    legal_partner,
    partners_with,
    sanitized,
    sanitized_wo,
  } = card;

  const page = dir === "deckpreview" ? sanitized_wo : sanitized;
  const params = ["commanders", "decks"].includes(dir) ? search : "";

  const items = [
    {
      condition: legal_commander,
      item: {
        key: "commanders",
        url: `/commanders/${page}${params}`,
        value: "As Commander",
      },
    },
    {
      condition: is_partner && cards?.length == 2,
      item: {
        key: "partner1",
        url: `/commanders/${cards && cards[0].url}`,
        value: cards && cards[0].name,
      },
    },
    {
      condition: is_partner && cards?.length == 2,
      item: {
        key: "partner2",
        url: `/commanders/${cards && cards[1].url}`,
        value: cards && cards[1].name,
      },
    },
    {
      condition: legal_partner && !(is_partner && cards.length > 1),
      item: {
        key: "partners",
        url: partners_with ? `/commanders/${partners_with}` : `/partners/${page}`,
        value: "As Partner",
      },
    },
    {
      condition: legal_companion,
      item: {
        key: "companions",
        url: `/companions/${page}`,
        value: "As Companion",
      },
    },
    {
      condition: !(is_partner && cards.length > 1),
      item: {
        key: "cards",
        url: `/cards/${sanitized_wo}`,
        value: "As Card",
      },
    },
    {
      condition: legal_commander,
      item: {
        key: "average-decks",
        url: `/average-decks/${page}`,
        value: "Average Deck",
      },
    },
    {
      condition: legal_commander,
      item: {
        key: "decks",
        url: `/decks/${page}${params}`,
        value: "Decks",
      },
    },
    {
      condition: combos && !is_partner,
      item: {
        key: "combos",
        url: `/combos/${sanitized_wo}`,
        value: "Combos",
      },
    },
  ];

  return items.filter((item) => item.condition).map(({ item }) => item);
};

const Breadcrumb = ({ breadcrumb }) => {
  const darkMode = useDarkMode(false);
  const dispatch = useDispatch();
  const { dir } = useParams();
  const { data } = useSelector((state) => state.pagedata);
  const { pathname, search } = useSelector((state) => state.router.location);

  const card = data?.container?.json_dict?.card;

  const onClickTab = (e, url) => {
    e.preventDefault();
    e.target.blur();
    dispatch(push(url, { noTop: true }));
  };

  const items = getItems({ card, dir, search });

  return (
    <nav className={classNames(styles.container, { [styles.dark]: darkMode.value })}>
      <ol className="breadcrumb">
        <li className="breadcrumb-item">
          <Link to="/">Home</Link>
        </li>
        {breadcrumb && (
          <>
            {breadcrumb.slice(0, -1).map((item) => (
              <li className="breadcrumb-item" key={Object.keys(item)[0]}>
                {Object.keys(item)[0] === "#" ? (
                  <a className="breadcrumb-item active">{Object.values(item)[0]}</a>
                ) : (
                  <Link
                    to={{
                      pathname: Object.keys(item)[0],
                      state: { noTop: true },
                    }}
                  >
                    {Object.values(item)[0]}
                  </Link>
                )}
              </li>
            ))}
            <li className="breadcrumb-item active" aria-current="page">
              {Object.values(breadcrumb[breadcrumb.length - 1])[0]}
            </li>
          </>
        )}
      </ol>
      {card && items.length > 1 && (
        <div className={styles.pad}>
          <nav className={classNames(styles.nav, "nav nav-pills")}>
            {items.map((item) => {
              const urlWithoutParams = item.url.split("?")[0];
              return (
                <a
                  role="tab"
                  className={classNames(styles.navItem, "nav-item nav-link", {
                    active: pathname.replace(/\/$/, "") === urlWithoutParams,
                  })}
                  href="#"
                  key={urlWithoutParams}
                  onClick={(e) => onClickTab(e, item.url)}
                  tabIndex={0}
                >
                  {item.value}
                </a>
              );
            })}
          </nav>
        </div>
      )}
    </nav>
  );
};

Breadcrumb.propTypes = {
  breadcrumb: PropTypes.arrayOf(PropTypes.object.isRequired),
};

export default Breadcrumb;
